// Converted from application/views/sculptures/seven-veils-m_v.php. Edit this component directly.
export default function SculpturesSevenVeilsMPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/seven-veils/seven-veils-m.jpg"} alt={"Seven Veils"} />
<figcaption>{"#1"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Seven Veils "}<small>{"(M)"}</small></h1>
<p>
<b>{"Dimensions: 1m high (3’ 3”)"}<br />{"\n                        Bronze"}<br /></b>
</p>
<p>{"\n                    One of the most famous and beautiful dancers in Paris during the First World War. Mata-Hari performed “The Dance of The Seven Veils”, first for the French troops, then for the German troops as the battlefront moved."}</p>
<p>
</p></div>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                She was later accused of swapping war secrets in bed, while she slept with generals on both sides..."}<br />{"She had lost her husband and two children, and now her family disowned her as a collaborator.\n            "}</p>
<p>{"\n                In fact she was an innocent scapegoat, but Mata-Hari was executed by a French firing squad in 1918.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/seven-veils/seven-veils-m-closeup.jpg"} alt={"Seven Veils Closeup"} />
<figcaption>{"#2"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/seven-veils/seven-veils-m-back.jpg"} alt={"Seven Veils Back"} />
<figcaption>{"#3"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                This scaled down version of a lifesize sculpture captures Mata- Hari in the crosshairs between Life and Death, escaping from a world which had brought her great success and terrible tragedy.\n            "}</p>
</div>
</div>
</div>
</>;
}
